var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoupe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "matrix(0.999153,0,0,1.02746,0.361166,-13.8823)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.836885,0,0,0.836885,1.02202,3.87089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5,26.58C3.15,26.58 0.42,23.85 0.42,20.5C0.42,17.15 3.15,14.42 6.5,14.42C9.85,14.42 12.58,17.15 12.58,20.5C12.58,23.85 9.85,26.58 6.5,26.58ZM6.5,15.58C3.78,15.58 1.58,17.79 1.58,20.5C1.58,23.21 3.79,25.42 6.5,25.42C9.21,25.42 11.42,23.21 11.42,20.5C11.42,17.79 9.22,15.58 6.5,15.58Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.591761,-0.591761,0.591761,0.591761,-11.6825,17.9728)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.18,
    y: 23.57,
    width: 1.15,
    height: 6.36
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoupe);
export default __webpack_public_path__ + "static/media/loupe.d454548ebc71b6ea356707ee4f279028.svg";
export { ForwardRef as ReactComponent };